export default __webpack_public_path__ + "static/tile-featured-3-a9284218e640a119ab04201a4f0d1a5c.jpg";